// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rAwN","left":"styles_left__eh4qU"};